import React from 'react';
import * as constant from './constants';
import Button from './../Button';
import ImageButton from './../Button/ImageButton';
import UtilsProfile from "../../utils/Profile";

import Asset from "../../requests/apa/Asset";
import Translator from './../../requests/apa/Translator';
import ProfileReadCache from '../../AAF/LoaderExp/ProfileReadCache';
import Utils from '../../utils/Utils';

import {
  RENDER_FAILURE,
  PROFILES,
  sendLoadAppErrorToNewRelic,
  sendLoadAppToNewRelic
} from "../../utils/newRelic_loadApp/newRelic-load-app";
import {AAF_MODAL_CHANGE_AAF_TO_CLARO_TV} from "../../actions/modal";
import logger from 'src/utils/logger/logger';

export class Start extends React.Component {
  constructor(props) {
    super(props);
  }

  getItems() {
    const { items, maxMembers, onSetAction } = this.props.props;
    const localItems = [...items];

    if (localItems && localItems.length && ((maxMembers - localItems.length) >= 1)) {
      const admin = UtilsProfile.getAdminMember(localItems);

      localItems.push({
        name: Translator.get('add_profile_label', 'Agregar Perfil'),
        imgSrc: UtilsProfile.getAddAvatar(),
        data: admin.data,
        clickHandler: (item) => {
          if (item.data && item.data.change_name) {
            onSetAction(constant.COMPLETE_PROFILE, item.data);
          } else {
            if (!ProfileReadCache.getEnableClick()) {
              return;
            }
            onSetAction(constant.ADD_PROFILE);
          }
        }
      });
    }

    return localItems;
  }

  componentDidMount() {
    Utils.modalType() !== AAF_MODAL_CHANGE_AAF_TO_CLARO_TV && UtilsProfile.setFocus('.container.profile .row.avatar-option .focusable');

    const { items } = this.props.props;
    items.length > 0
      ? sendLoadAppToNewRelic(PROFILES)
      : sendLoadAppErrorToNewRelic(RENDER_FAILURE);
  }

  componentDidCatch(error, errorInfo) {
    sendLoadAppErrorToNewRelic(RENDER_FAILURE)
  }

  render() {
    const { onSetAction } = this.props.props;
    const items = this.getItems();

    return (
      <div className='container profile'>
        <div className='row'>

        </div>
        <div className='row title'>
          <span>
            {Translator.get('view_profiles_title', '¿Quien esta viendo ahora?')}
          </span>
        </div>
        <div className='row avatar-option'>
          <div className='container'>{getAvatars(items)}</div>
        </div>
        <div className='row button'>
          <Button order={['text']} className='button' text={Translator.get('manage_profiles_btn', 'Administrar Perfiles')}
            onClick={() => {
              onSetAction(constant.ADMIN_PROFILE);
            }} />
        </div>
      </div>
    );
  }
}


const getAvatars = (items) => {

  if (items && items.length) {
    return items.map((item, index) => {

      const imgSrc = Utils.adaptImageProtocol(`${item.imgSrc}${UtilsProfile.getAddAvatar() === item.imgSrc ? '' :'&impolicy=resize&vwidth=150'}` || Asset.get('placeholder_profile', '/images/placeholder_talent_movie.png'));

      return (
        <div className='image'>
          <ImageButton order={['text']} className='button' imgSrc={imgSrc}
            key={item.partnerUserId}
            text={item.name}
            onClick={(e) => {
              item.clickHandler(item);
            }}
            onBlur={() => logger.debug('onBlur')}
            imgId = {`a.imgStart${index}`}
          />
        </div>
      );
    });
  }
  else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Profile/Start.jsx